export default "__VITE_ASSET__ChWl4iLC__"